import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            答疑解惑
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于快看影视，你可能想了解的一切
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-3">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 font-bold flex-shrink-0">Q:</span>
                  {item.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-5">
                  <span className="text-accent-500 font-bold">A: </span>
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}